import React from "react";
import styles from "./Item.module.css";
import { Link } from "react-router-dom";
import Counter from "./Counter";
import { useDispatch } from "react-redux";
import { removeItemFromCart } from "../../redux/userSlice";
import { useState } from "react";

function Item({ product, handleCLose }) {
  const dispatch = useDispatch();
  const [stockAlert, setStockAlert] = useState(false);

  return (
    <div className={"d-flex mb-4 me-3 " + styles.item}>
      <div>
        <img src={product.image} alt="" className={styles.cart_img} />
      </div>
      <div
        className={
          styles.item_details + " d-flex flex-column justify-content-between"
        }
      >
        <div className="d-flex justify-content-between">
          <Link
            to={`/product/${product.slug}`}
            onClick={handleCLose}
            className={styles.product_name}
          >
            {product.name}
          </Link>
          <p className={styles.product_price}>USD {product.price}</p>
        </div>
        <div className="d-flex justify-content-between mb-2">
          <div className="d-flex align-items-center">
            <p className="m-0">Qty: </p>
            <Counter
              initial={product.qty}
              product={product}
              setStockAlert={setStockAlert}
            />
          </div>
          <button
            className={styles.remove_btn}
            onClick={() => dispatch(removeItemFromCart(product))}
          >
            Remove
          </button>
        </div>
        {stockAlert && (
          <small className={styles.no_stock}>
            Sorry, no more products in stock!
          </small>
        )}
      </div>
    </div>
  );
}

export default Item;
